export const loading = state => state.loading
export const loginPop = state => state.loginPop
export const user = state => state.user
export const eid = state => state.eid
export const page = state => state.page
export const ClientType = state => state.ClientType
export const errorMsg = state => state.errorMsg
export const noDataTip = state => state.noDataTip
export const refresh = state => state.refresh
export const domainlist = state => state.domainlist
export const domainInfo = state => state.domainInfo
export const isInit = state => state.isInit
export const aaEnrollment = state => state.aaEnrollment
export const initAaEnrollment = state => state.initAaEnrollment
export const aaEnrollmentList = state => state.aaEnrollmentList
export const topicQuesBankConfiguration = state => state.topicQuesBankConfiguration
export const topicQuesBankSectionConfiguration = state => state.topicQuesBankSectionConfiguration
export const channelid = state => state.channelid
export const specialConfiguration = state => state.specialConfiguration
export const showAppTips = state => state.showAppTips
export const specialTopicBuyDialogVisible = state => state.specialTopicBuyDialogVisible